import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const problems = [{
  short: 'Llegás sin saber qué hacer',
  full: 'Sin saber qué rutina o progresión vas a trabajar hoy.'
}, {
  short: 'Trucos que no progresan',
  full: 'Sin estructura clara para pasar de un nivel al siguiente.'
}, {
  short: 'Te lesionás seguido',
  full: 'Molestias articulares que no sabés cómo prevenir.'
}, {
  short: 'Siempre los mismos básicos',
  full: 'No sabés cómo transicionar a los ejercicios avanzados.'
}, {
  short: 'Front Lever inalcanzable',
  full: 'Te falta un sistema de tensión estructurado.'
}, {
  short: 'Tips sueltos de Instagram',
  full: 'Sin un método claro que respalde tu entrenamiento.'
}, {
  short: 'No sabés autorregular',
  full: 'Tu entrenamiento se vuelve un caos según tu energía.'
}, {
  short: 'Fin de mes sin progreso',
  full: 'Sin sobrecarga progresiva, no avanzás.'
}];
export function ProblemAgitation() {
  return <section className="py-10 md:py-20 relative" data-id="element-229">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-230">
        {/* Compact header */}
        <FadeIn className="text-center mb-8 md:mb-10" data-id="element-231">
          <div className="inline-flex items-center gap-2 bg-red-500/10 border border-red-500/30 text-red-400 px-3 py-1 rounded-full text-[10px] md:text-xs font-bold tracking-widest mb-4" data-id="element-232">
            <AlertTriangle className="w-3 h-3" data-id="element-233" /> ¿TE PASA ESTO?
          </div>
          <h2 className="text-2xl md:text-4xl leading-tight max-w-3xl mx-auto" data-id="element-234">
            Si entrenás calistenia en Argentina,{' '}
            <span className="text-brand-orange" data-id="element-235">esto te suena familiar:</span>
          </h2>
        </FadeIn>

        {/* Compact 2-col grid of problem cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 md:gap-3 mb-10 md:mb-12" data-id="element-236">
          {problems.map((problem, i) => <FadeIn key={i} delay={i * 0.04} direction="up" data-id="element-237">
              <div className="group relative flex items-start gap-3 bg-brand-card border border-brand-border rounded-lg p-3 md:p-3.5 hover:border-red-500/40 hover:bg-brand-cardHover transition-all duration-300 h-full overflow-hidden" data-id="element-238">
                {/* Red accent line left */}
                <div className="absolute left-0 top-0 bottom-0 w-0.5 bg-red-500/40 group-hover:bg-red-500 transition-colors" data-id="element-239" />

                {/* X icon */}
                <div className="shrink-0 bg-red-500/10 border border-red-500/20 p-1.5 rounded-md mt-0.5" data-id="element-240">
                  <X className="w-3.5 h-3.5 md:w-4 md:h-4 text-red-500" data-id="element-241" />
                </div>

                {/* Content */}
                <div className="min-w-0 flex-grow" data-id="element-242">
                  <h3 className="text-sm md:text-base font-bold leading-tight mb-0.5 text-brand-text" data-id="element-243">
                    {problem.short}
                  </h3>
                  <p className="text-[11px] md:text-xs text-brand-muted leading-snug" data-id="element-244">
                    {problem.full}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>

        {/* Closing question — more compact, with visual emphasis */}
        <FadeIn delay={0.3} data-id="element-245">
          <div className="relative text-center bg-gradient-to-br from-brand-card to-brand-dark border border-brand-orange/30 rounded-2xl p-6 md:p-10 overflow-hidden" data-id="element-246">
            <div className="absolute -top-20 -right-20 w-60 h-60 bg-brand-orange/10 rounded-full blur-3xl pointer-events-none" data-id="element-247" />
            <h3 className="relative text-2xl md:text-5xl text-glow leading-tight" data-id="element-248">
              ¿Cuántos meses más vas a{' '}
              <span className="text-brand-orange" data-id="element-249">entrenar improvisando?</span>
            </h3>
          </div>
        </FadeIn>
      </div>
    </section>;
}